import { render, staticRenderFns } from "./DashboardConfig.vue?vue&type=template&id=f4690310&scoped=true&"
import script from "./DashboardConfig.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardConfig.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4690310",
  null
  
)

export default component.exports